export const EMPTY_ARRAY = [] as never[];
